import { useEffect, useState } from "react";
import { ExternalLink } from "lucide-react";
import api, { API } from "@/lib/api";

const DOCS = [["full_report", "Full Report"], ["executive_summary", "Executive Summary"], ["comparison_table", "Provider Comparison"]];

export const SampleReportViewer = () => {
  const [slot, setSlot] = useState("full_report");
  const [pages, setPages] = useState(0);
  useEffect(() => {
    setPages(0);
    api.get(`/power-study/sample-report/${slot}/pages`).then((r) => setPages(r.data.pages)).catch(() => {});
  }, [slot]);

  return (
    <div data-testid="sample-report-viewer">
      <p data-testid="sample-report-label" className="inline-block font-mono text-[11px] font-bold uppercase tracking-widest text-[#F59E0B] border border-[#F59E0B]/40 bg-[#F59E0B]/10 rounded px-3 py-1.5">
        SAMPLE REPORT – fictional site for illustration only
      </p>
      <div className="flex flex-wrap items-center gap-2 mt-5">
        {DOCS.map(([k, l]) => (
          <button key={k} data-testid={`sample-tab-${k}`} onClick={() => setSlot(k)}
            className={`text-sm px-4 py-2 rounded-full border transition-colors ${slot === k ? "border-[#84CC16] bg-[#84CC16]/10 text-[#84CC16]" : "border-white/15 text-slate-300 hover:border-white/40"}`}>{l}</button>
        ))}
        <a href={`${API}/power-study/sample-report/${slot}.pdf`} target="_blank" rel="noopener noreferrer" data-testid="sample-open-pdf"
          className="ml-auto inline-flex items-center gap-1.5 text-sm text-[#3B82F6] hover:text-[#84CC16]">Open sample PDF <ExternalLink size={14} /></a>
      </div>
      <div className="mt-5 space-y-4 max-h-[80vh] overflow-y-auto rounded-xl border border-white/10 bg-[#0B0F17] p-3 sm:p-5" data-testid="sample-pages">
        {pages === 0 && <p className="text-slate-500 font-mono text-sm py-10 text-center">Loading sample…</p>}
        {Array.from({ length: pages }, (_, i) => (
          <img key={`${slot}-${i}`} src={`${API}/power-study/sample-report/${slot}/page/${i + 1}`} alt={`Sample ${slot} page ${i + 1}`}
            loading="lazy" data-testid={`sample-page-${i + 1}`} className="w-full max-w-3xl mx-auto rounded shadow-lg bg-white" />
        ))}
      </div>
    </div>
  );
};

export default SampleReportViewer;
